import React from 'react';
import { Preloader } from 'framework7-react';

import { I18n } from 'Locales';

import './style.scss';

const LoadingScreen = () => (
  <div id="loading-screen">
    <div className="loading-container">
      <Preloader size={100} />

      <div className="loading-message">{I18n.t('flow:waitingForUpload')}</div>
    </div>
  </div>
);

export default LoadingScreen;
